import request from '../utils/request'
export default {
	
	/*-------------------------------------------------------------人事 管理员 start-----------------------------------------------------------  */
	//人事-薪酬-公司部门列表 - 李旭
	getFundsList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/money/query`,
			data: params
		})
	},
	//人事-薪酬-填报 - 李旭  假的接口
	saveFundsList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/money/save`,
			data: params
		})
	}
}